import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Log } from 'ng2-logger';

import { Audit } from '@models/audit.model';

import { TableConfig } from '@app/shared/util/table-config.utils';
import { TableComponent } from '@components/custom-table/table.component';

@Component({
    selector: 'app-audits-table',
    templateUrl: './audits-table.component.html',
    styleUrls: ['./audits-table.component.scss']
})
export class AuditsTableComponent {
    _logger = Log.create(AuditsTableComponent.name);

    @ViewChild(TableComponent, {static: true}) table: TableComponent;

    @Input() audits: Audit[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;
    @Input() operations: any = [];
    @Input() entity: any;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();

    onPageChange(tableConfig: TableConfig) {
        this._logger.info("onPageChange::", tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info("onSortChange::", tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info("onFilterChange::", tableConfig);
        this.filterChange.emit(tableConfig);
    }

}
